import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { Member } from '@/lib/use-session';
import type { ReportError } from '@/lib/report-error';

export interface RouterContext {
  queryClient: QueryClient;
  member: Member | null;
  reportError: ReportError;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="page-root">
      <Outlet />
    </div>
  );
}
